<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
      <div v-if="readyToWork">
        <form v-on:submit.stop.prevent="onSubmit">

          <div class="fl frstShortSeconLong" id="headOutgoing">
            <div v-show="!isPDL">
              <div class="input_box">
                <label  class="left">Тип продукта</label>
                <select v-model="productId">
                  <option :value="option.ProductType" v-for="option in getProduct">{{option.DlProductTypeName}}</option>
                </select>
              </div>
              <div class="input_box">
                <label  class="left">Сумма займа</label>
                <select v-model="requestSum">
                  <option :value="Amount" v-for="Amount in getAvailableSum">{{Amount}}</option>
                </select>
              </div>
              <div class="input_box" v-show="getAvailablePeriod.length > 1">
                <label  class="left">Срок займа {{getSelectedPskInfo.calcWeekTitle}}</label>
                <select v-model="CALC_WEEK">
                  <option :value="Period" v-for="Period in getAvailablePeriod">{{Period}}</option>
                </select>
              </div>
            </div>
            <div>
              <p>Тип обзвона: <b>{{leadGroupName}}</b></p>
              <p>Фио клиента: <b>{{displayName}}</b></p>
              <div class="fl callingBox" id="startCall" v-show="!additionalPhoneFlag">
                <div class="button" v-on:click="startCalling(1)" >Позвонить</div>
                <div style="display: none">{{valueVuex['request']['PHONE']}}</div>
                <div class="button" v-on:click="showAdditionalPhone" >Добавить номер телефона</div>
              </div>
              <div v-show="additionalPhoneFlag" class="fl callingBox">
<!--                <formInput :refs="'PHONE_ADDITIONAL'" :form="'LeadInfo'"></formInput>-->
                <formInput :refs="'PHONE'" :form="'request'"></formInput>
                <div class="button" v-on:click="startCalling(2)" >Позвонить</div>
              </div>
            </div>
          </div>

          <productInfo v-show="!isPDL"></productInfo>
          <dealInfo v-show="isPDL" :leadTmp="PdlData"></dealInfo>

          <statusBar
            v-on:loadNewLead="loadNewLead"
            :PdlData="PdlData"
          />

          <formRequest v-on:loadNewLead="loadNewLead"></formRequest>

        </form>

      </div>
      <div class="loaderWrap" v-else>
        <loader ></loader>
      </div>
    </div>
    <div class="borderBox" id="operatorScript">
      <OperatorScriptLayout :parentID="'0'" :sourceId="outScriptsId"></OperatorScriptLayout>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex'
  import DataForInput from '@/gavnoCode/longFormOptions';

  export default {
    name: "outgoing",
    components: {
      dealInfo: () => import('@/components/dealInfo'),
      formRequest: () => import('@/components/forms/formRequest'),
      formSelect: () => import('@/components/forms/formSelect'),
      productInfo: () => import('@/components/productInfo'),
      statusBar: () => import('@/components/status/statusBar'),
      loader: () => import('@/components/loader'),
      OperatorScriptLayout: () => import('@/components/OperatorScript/OperatorScriptLayout'),
      formInput: () => import('@/components/forms/formInput'),
      // counterOutgoing: () => import('@/components/status/counterOutgoing')
    },
    data: function () {
      return {
        requestField: {},
        readyToWork: false,
        additionalPhoneFlag: false,
        leadTmp: {},
        PdlData: {},
      }
    },
    methods: {
      onSubmit: function () {
        //блокирем отправку формы по православному submit
      },
      loadOperatorScript:function () {
        if (this.getIncomeScripts.length == 0) {
          this.$myApi.scriptContent()
          .then((result)=>{
            this.$store.dispatch('setScripts',result)})
          .catch((msg)=>{console.log(msg)});
        }
      },
      showAdditionalPhone:function(){
        this.additionalPhoneFlag = true;
      },
      clearVuex(){
        this.leadTmp = {};
        return this.$store.dispatch('resetToDefault');
      },
      getLead(){
        return new Promise((resolve, reject) => {
          this.$myApi.SendRequest({
            action: 'Operator_GetLeadInfo',
            PrevLeadGuid: (localStorage.getItem('leadInfo') == '') ? '' : localStorage.getItem('leadInfo'),
          }, this, 'GetLeadInfo', false).then((result) => {
            this.leadTmp = result;
            if (result.PdlData != undefined) {
              this.PdlData = result.PdlData;
            } else {
              this.PdlData = {};
            }
            try {
              localStorage.setItem('leadInfo', result.LeadGUID);
              let timeCur = new Date();
              localStorage.setItem('leadInfoTimeUpdate', timeCur.getTime());
            } catch (e) {
              console.log(e);
            }

            resolve();
          }).catch((result)=>{
            try {
              if (result.Response.ExecutionError.ExecutionErrorMessage == "Процедура вернула пустой набор; ") {
                let counterReload = 30;
                let reloadTimer = setInterval(()=>{
                  this.$store.commit('setContent', 'Нет клиентов для обзвона, повторная попытка загрузить форму через<br/> <b>' + counterReload + '</b> секунд');
                  counterReload += -1;
                  if (counterReload <= 0 ) {
                    clearInterval(reloadTimer);
                    this.$store.commit('hideModal');
                    this.loadNewLead();
                  }
                }, 1000);
              }
            } catch (e) {
              this.$store.commit('setContent', 'Ошибка: ' + JSON.stringify(result));
              this.$store.commit('showModal');
            }
            reject();
          });
        });
      },
      setMarketData(){
        return new Promise((resolve, reject) => {
          this.leadTmp.REFFER = 'Телемаркетинг';
          this.leadTmp.WHERE_TO_FIND_US = this.leadTmp['LeadType'];
          this.$store.dispatch('saveSendData', {
            target: 'requestType',
            form: 'status',
            value: 'outgoing'
          });
          resolve();
        });
      },
      setLeadListData(){
        //сохраняем основные данные лида в форму
        return this.$store.dispatch('setRequestField', {
          form: 'request',
          values: this.leadTmp
        });
      },
      setLeadListInfo(){
        //сохроняем данные для связи лида с базой
        return  this.$store.dispatch('setRequestField', {
          form: 'LeadInfo',
          values: this.leadTmp
        });
      },
      setLeadOperatorData(){
        //сохроняем данные ранне введеные оператором
        return new Promise((resolve, reject) => {
          if (typeof this.leadTmp['LeadData'] === 'object') {
            this.$store.dispatch('setRequestField', {
              form: 'request',
              values: this.leadTmp['LeadData']['request']
            }).then(()=>{
              resolve();
            });
          } else {
            resolve();
          }
        });
      },
      updateDealType(){
        //надо бы переписать, что бы кровь из глаз не шла
        return new Promise((resolve, reject) => {
          this.$myApi.SendRequest({action:'Operator_Get_Ref_DealType'},this,'mountedPsk',false)
          .then((result)=>{
            if (result.length > 0) {
              //если есть массив, значит пришли новые продукты, добавляем в фронт и сохроняем к нам в бд
              this.$store.dispatch('addPskTable', result);
              this.$myApi.saveDefaultDealType(result).then(()=>{
                resolve();
              }).catch(e=>{
                e['asd']='asd';
                reject();
              });
            } else {
              this.$myApi.getDefaultDealType()
              .then((result)=>{
                this.$store.dispatch('addPskTable', result);
                resolve();
              })
              .catch(e=>{
                console.log(e);
                reject();
              });
            }
          }).catch(e=>{
            console.log(e);
            alert('Ошибка :' + e );
          });
        });
      },
      checkVersion(){
        //проверяем нет ли свежего обновления на сайте, если есть обновляем страницу для загрузки нового гавнокодика
        return new Promise((resolve,reject) => {
          this.$myApi.singleRequest({
            action: 'Operator_checkVersion'
          }).then((res)=>{
            if (localStorage.getItem('cache') === null) {
              localStorage.setItem('cache', res.cache)
            } else if (localStorage.getItem(('cache')) != res.cache) {
              localStorage.setItem('cache', res.cache)
              document.location.reload();
            }
            resolve(res);
          })
          .catch((res)=>{
            this.$store.commit('setContent', 'Ошибка<hr>' + JSON.stringify(res));
            this.$store.commit('showModal');
            reject(res);
          });
        });
      },
      kostilPhoneTudiSudi(){
        // let leadPhone = this.valueVuex['request']['PHONE'];
        //
        // this.$store.dispatch('saveSendData',{
        //   target:'PHONE_FOR_CALL',
        //   form:'LeadInfo',
        //   value: leadPhone
        // });
        // this.$store.dispatch('saveSendData',{
        //   target:'PHONE',
        //   form:'request',
        //   value: ''
        // });
      },
      loadNewLead: function (frstStart = false) {
        this.readyToWork = false;
        let alertMsg = '';
        if (frstStart) {
          let curTime = new Date();
          if (curTime.getTime() -  parseInt(localStorage.getItem('leadInfoTimeUpdate'), 10) > 3600000) {
            localStorage.setItem('leadInfo', '');
          } else {
            alertMsg  = 'Что бы получить новую карточку вам нужно прозвонить текущую';
          }
        } else {
          localStorage.setItem('leadInfo', '');
        }
          try {
            this.checkVersion()
            .then(this.updateDealType)
            .then(this.clearVuex)
            .then(this.getLead)
            .then(this.setMarketData)
            .then(this.setLeadListData)
            .then(this.setLeadListInfo)
            .then(this.setLeadOperatorData)

            .then(()=>{
              this.kostilPhoneTudiSudi();
              this.readyToWork = true;
              console.log(alertMsg.length)
              if (alertMsg.length > 0) {
                alert(alertMsg);
              }
            })
            .catch((error)=>{console.log(error)})


          } catch (e) {
            this.$store.commit('setContent', 'Ошибка: ' + JSON.stringify(result));
            this.$store.commit('showModal');

            alert('!!!!! СКОПИРОВАТЬ и ОТПРАВИТЬ РАЗРАБОТЧИКУ !!!!! ->> loadNewLead out.vue' + JSON.stringify(result) +
              ' #### ' +
              JSON.stringify(e));
          }
        },
      SaveThisLead: function () {
        this.readyToWork = false;
        let saveStatus = Object.assign({}, this.valueVuex);
      },
      startCalling: function (type) {
        // let phone = (type === 1) ? this.valueVuex['LeadInfo']['PHONE_FOR_CALL'] : this.valueVuex['LeadInfo']['PHONE_ADDITIONAL'];
        // if (phone.length < 18) {
        //   this.$store.commit('setContent', 'Не заполнено поле телефон');
        //   this.$store.commit('showModal');
        // }else {
        //   this.$myApi.singleRequest({
        //     action:'asterisk_startCall',
        //     phone:this.valueVuex['LeadInfo']['PHONE'],
        //     // phone:phone
        //   }).then((res)=>console.log(res))
        //   .catch((res)=>console.log(res));
        // }
        this.$myApi.singleRequest({
          action:'asterisk_startCall',
          phone:this.valueVuex['request']['PHONE'],
        }).then((res)=>console.log(res))
        .catch((res)=>console.log(res));
      }
    },
    computed: {
      displayName: function () {
        return this.valueVuex['request']['LAST_NAME'] + ' '  +this.valueVuex['request']['FIRST_NAME'] +  ' ' + this.valueVuex['request']['SECOND_NAME'];
      },
      ...mapGetters(['getProfile','getProduct','getAvailableSum','getIncomeScripts','getAvailablePeriod','getSelectedPskInfo','isPDL','outScriptsId']),
      ...mapState({
        valueVuex: state => state.requestField['sendData'],
        leadGroupName: state => state.requestField['sendData']['LeadInfo']['LeadType']
      }),
      productId: {
        get(){
          return this.valueVuex['request']['PRODUCT_ID']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'PRODUCT_ID',
            form:'request',
            value: value
          });
        }
      },
      requestSum: {
        get(){
          return this.valueVuex['request']['CALC_SUMM']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'CALC_SUMM',
            form:'request',
            value: value
          });
        }
      },
      CALC_WEEK: {
        get(){
          return this.valueVuex['request']['CALC_WEEK']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'CALC_WEEK',
            form:'request',
            value: value
          });
        }
      }
    },
    watch: {},
    mounted() {
      if (localStorage.getItem('leadInfo') == null) {
        localStorage.setItem('leadInfo', '');
      }
      if (localStorage.getItem('leadInfoTimeUpdate') == null) {
        let timeCur = new Date();
        localStorage.setItem('leadInfoTimeUpdate', timeCur.getTime() - 3600000);
      }



      this.$store.dispatch('loadScriptById','115');
      this.$store.dispatch('loadScriptById','116');
      this.$store.dispatch('loadScriptById','117');
      this.$store.dispatch('loadScriptById','118');
      this.$store.dispatch('loadScriptById','1');

      this.loadNewLead(true);
    }
  }
</script>

<style scoped>
  #headOutgoing{align-items: center;text-align: left;padding: 0 0 20px;}
  #headOutgoing p {margin: 0;padding: 0;}
  #pageContent{display: flex;align-items: flex-start;justify-content: flex-start;width: 100%;}
  #formArea{width: 900px;}

  .loaderWrap{min-height: 66vh;height: 1px;}
  #operatorScript{    margin: 0;
    width: calc(100% - 1070px);
    text-align: left;
    position: fixed;
    top: 10px;
    right: 10px;
    height: calc(100vh - 40px);
    overflow-x: scroll;}
  #startCall{margin-top: 30px;}
  .callingBox{justify-content: flex-start;align-items: center}
  .callingBox .button{border: 6px solid;border-top:12px solid;margin: 0 10px}

  @media screen and (max-width: 1600px) {
    #pageContent{
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
    }
    #operatorScript{
      margin: 10px 0 10px 90px;
      width: 900px;
      position: relative;
      top:0;
      right:0;
      height: auto;
      overflow: inherit;
    }
  }
</style>
